import { Flex, JaneLogo } from '@iheartjane/reefer';

import { KioskThemeProvider } from '../providers';

export const LogoPage = () => (
  <KioskThemeProvider>
    <Flex
      alignItems="center"
      justifyContent="center"
      height="100vh"
      width="100vw"
    >
      <JaneLogo size="lg" />
    </Flex>
  </KioskThemeProvider>
);
